<script setup lang="ts">
import { motion } from "motion-v";

interface Props {
  as?: string;
}

withDefaults(defineProps<Props>(), {
  as: "div",
});

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 10,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 350,
      damping: 26,
    },
  },
  exit: {
    opacity: 0,
    scale: 0.9,
    y: -6,
    transition: { duration: 0.15, ease: "easeIn" },
  },
};
</script>

<template>
  <motion.component
    :is="as"
    layout
    :variants="itemVariants"
    class="origin-center"
  >
    <slot />
  </motion.component>
</template>
